import { Component, ParentProps } from "solid-js";
import { Locale } from "../../i18n.js";

interface GetFlagImgProps extends ParentProps {
  locale: Locale;
  size?: number;
}

const GetFlagImg: Component<GetFlagImgProps> = (props) => {
  console.log(props.locale);
  const size = props.size || 16;
  return (
    <img
      src={`https://flagcdn.com/${size}x${Math.round(size * 0.75)}/${props.locale}.png`}
      srcSet={`https://flagcdn.com/${size * 2}x${Math.round(size * 1.5)}/${props.locale}.png 2x, https://flagcdn.com/${size * 3}x${Math.round(size * 2.25)}/${props.locale}.png 3x`}
      width={size}
      height={Math.round(size * 0.75)}
      alt={props.locale}
    >
      {props.children}
    </img>
  );
};

export default GetFlagImg;
